<template>
    <div>
        <div class="flex w-full">
            <div class="w-1/6 mr-4">
                <div>
                    <label class="text-sm text-grey-darkest">Filter by Fixed Date</label>
                    <multiselect :options="dateRanges"
                                 v-model="selectedFixedDateRangeIdentifier"
                                 :show-labels="false"
                                 @input="setFixedDateRange(selectedFixedDateRangeIdentifier)"
                                 @remove="clearDates"
                                 track-by="id" label="name" class="mb-2 cursor-pointer">
                    </multiselect>
                </div>
            </div>
            <div class="w-1/5 mr-4">
                <div class="flex">
                    <v-date-picker v-model="selectedDateRange" is-range :masks="rangeMask" @input="setFixedDateRange({id:0})" :popover="{ visibility: 'click' }">
                        <template v-slot="{ inputValue, inputEvents }">
                            <div class="flex w-full">
                                <div class="flex-column mr-2">
                                    <label class="text-sm text-grey-darkest">Start Date</label>
                                    <input
                                        :value="inputValue.start"
                                        v-on="inputEvents.start"
                                        :class="(requiredFields && requiredFields.start_date) ? 'required-field-color' : ''"
                                        class=" mr-1 cursor-pointer date-picker-input border-1 border-grey focus:outline-none px-2 rounded-l rounded-r text-grey-darkest text-sm w-full"
                                    />
                                    <div class="text-red text-xs" v-if="(requiredFields && requiredFields.start_date)">{{
                                            requiredFields.start_date
                                        }}
                                    </div>
                                </div>
                                <div class="flex-column">
                                    <label class="text-sm text-grey-darkest">End Date</label>
                                    <input
                                        :value="inputValue.end"
                                        v-on="inputEvents.end"
                                        :class="(requiredFields && requiredFields.end_date) ? 'required-field-color' : ''"
                                        class="cursor-pointer date-picker-input border-1 border-grey focus:outline-none px-2 rounded-l text-grey-darkest text-sm w-full"
                                    />
                                    <div class="text-red text-xs" v-if="(requiredFields && requiredFields.end_date)">{{
                                            requiredFields.end_date
                                        }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-date-picker>
                    <div class="flex-column">
                        <label class="text-sm text-grey-darkest"></label>
                        <div
                            class="-ml-0 border-b-1 border-grey border-r-1 border-t-1 cursor-pointer flex hover:bg-grey hover:text-white text-grey-darkest items-center px-2 rounded-r cross-btn"
                            @click.stop="clearDates">
                            <i class="material-icons text-sm">clear</i>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!isPm" class="w-1/6 mr-4">
                <label class="text-sm text-grey-darkest">Filter by User</label>
                <multiselect class="cursor-pointer" :options="usersOptions" v-model="selectedUser" :show-labels="false" :class="(requiredFields && requiredFields.user) ? 'has-error' : ''"
                             track-by="id" label="name"></multiselect>
                <div class="text-red text-xs" v-if="(requiredFields && requiredFields.user)">{{
                        requiredFields.user
                    }}
                </div>
            </div>
            <div v-if="isPm" class="w-1/6 mr-4">
                <label class="text-sm text-grey-darkest">Filter by Stage</label>
                <multiselect class="cursor-pointer" :options="stagesOptions" v-model="selectedStage" :show-labels="false" :class="(requiredFields && requiredFields.stage) ? 'has-error' : ''"
                             track-by="id" label="short_description"></multiselect>
                <div class="text-red text-xs" v-if="(requiredFields && requiredFields.stage)">{{
                        requiredFields.stage
                    }}
                </div>
            </div>
            <div class="w-1/6 mr-4">
                <div>
                    <label class="text-sm text-grey-darkest">Filter by {{ getFieldLabel(fieldLabels, 'office') }}</label>
                    <multiselect
                        :options="offices"
                        v-model="selectedOffices"
                        :show-labels="false"
                        @remove="selectedOffice = null"
                        track-by="id"
                        label="code"
                        group-values="group"
                        group-label="code"
                        :group-select="true"
                        class="mb-2 cursor-pointer"
                        :multiple="true"
                    >
                    </multiselect>
                </div>
            </div>
            <div class="w-1/6 mr-4" id="contract-type-filter">
                <div>
                    <label class="text-sm text-grey-darkest">Filter by {{ getFieldLabel(fieldLabels, 'contract-type') }}</label>
                    <multiselect :options="contractTypes"
                                 v-model="selectedContractType"
                                 :show-labels="false"
                                 track-by="id" label="code" class="mb-2 cursor-pointer">
                    </multiselect>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Mixin from './mixin';

import Datepicker  from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';
import moment      from 'moment';
// import 'v-calendar/lib/v-calendar.min.css';

export default {
    mixins    : [Mixin],
    name      : 'report-filter',
    components: {Datepicker, Multiselect},
    props     : [
        'user',
        'users',
        'dateRange',
        'office',
        'contractType',
        'fixedDateRangeIdentifier',
        'isPm',
        'projectStages',
        'masks',
        'fieldLabels'
    ],
    data() {
        return {
            rangeMask: {
                input: this.masks.moment_mask,
            },
            usersOptions                    : [],
            stagesOptions                   : [],
            selectedUser                    : this.user ? this.user : null,
            selectedStage                    : null,
            selectedDateRange               : this.dateRange ? {
                start: moment(this.dateRange.start).format('MM/DD/YYYY'),
                end  : moment(this.dateRange.end).format('MM/DD/YYYY')
            } : null,
            offices                         : [{
                code: 'All',
                group:[]
            }],
            selectedOffices                 : [],
            contractTypes                   : [],
            selectedContractType            : null,
            dateRanges                      : [],
            selectedFixedDateRangeIdentifier: this.fixedDateRangeIdentifier !== null ? this.fixedDateRangeIdentifier : null,
            requiredFields                  : null
        }
    },

    watch: {
        selectedUser() {
            this.updateFilterUri();
        },

        selectedOffices() {
            this.updateFilterUri();
        },

        selectedContractType() {
            this.updateFilterUri();
        },

        selectedFixedDateRangeIdentifier() {
            if(this.selectedFixedDateRangeIdentifier && this.requiredFields) {
                this.requiredFields.start_date = null
                this.requiredFields.end_date = null
            }
            this.updateFilterUri();
        },

        selectedStage() {
            if(this.selectedStage && this.requiredFields && this.requiredFields.stage) {
                this.requiredFields.stage = null
            }
            this.updateFilterUri();
        },
    },

    created() {
        this.usersOptions = this.users;
        this.stagesOptions = this.projectStages;
        this.getContractTypes();
        this.getOffices();
        this.fetchData();
        this.updateFilterUri();
    },

    mounted() {
        let self = this;
        Bus.$on('filterFieldsRequired', data => {
            self.requiredFields = data;
        });
    },

    methods: {
        selectedDateRangeChanged() {
            this.selectedFixedDateRangeIdentifier = null;
            this.updateFilterUri();
        },

        fetchData() {
            let self = this;
            axios.get(route('date-ranges')).then((data) => {
                self.dateRanges = data.data.dateRanges;
            });
        },

        clearDates() {
            this.selectedDateRange = null;
            this.updateFilterUri();
        },
        getOffices() {
            let self = this;
            axios.get(route('api.settings.codes.office.index')).then((response) => {
                self.offices[0].group = response.data;
                let office = JSON.parse(this.office);
                if(office) {
                    self.selectedOffices = self.offices[0].group.filter((element)=>{
                        return office.find((aux)=> aux === element.id);
                    })
                }
            });
        },
        getContractTypes() {
            let self = this;
            axios.get(route('api.settings.codes.contract-type.index')).then((response) => {
                self.contractTypes = response.data;
                self.contractTypes.unshift({id: 0, code: 'All'});
                let contract = this.contractType;
                if (contract != undefined) {
                    self.selectedContractType = _.find(self.contractTypes, function (o) {
                        return o.id === Number(contract);
                    })
                }
            });
        },

        updateFilterUri() {
            this.getFilter();
            this.$emit('updated-filter', this.uri);
        },
        setFixedDateRange(dateRange) {
            if (!dateRange) return;
            this.selectedFixedDateRangeIdentifier = this.dateRanges[dateRange.id];
            if(dateRange.id > 0)
                this.selectedDateRange                = {
                    start: moment(this.dateRanges[dateRange.id].startDate).format('MM/DD/YYYY'),
                    end  : moment(this.dateRanges[dateRange.id].endDate).format('MM/DD/YYYY')
                };
        },
        maxDate() {
            return moment().add(1, 'y').toDate();
        },
        formatDateRange(){
            if(!this.selectedDateRange)
                return '';

            let dates = this.selectedDateRange;
            return `${moment(dates.start).format(this.masks.moment_mask)} - ${moment(dates.end).format(this.masks.moment_mask)}`;
        },
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
.date-picker-input {
    padding: .61rem .5rem !important;
}
.cross-btn {
    height: 38px;
    margin-top: 7px;
}
</style>
